import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../Services/auth.service';
import { Router } from '@angular/router';
import { AuthUser } from '../Entities';
import { MenuService } from 'src/app/Services/menu.service';
import Swal from 'sweetalert2';
import { SwalCustomProps } from '../Utils/SwalCustomClass';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private menuService: MenuService
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const authData = <AuthUser>JSON.parse(localStorage.getItem('authUser')!);

    const token: string = authData?.token!;

    let request = req;

    if (token) {
      request = req.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.router.navigateByUrl('/');
          this.authService.authUser = new AuthUser();
          this.menuService.setMenu([]);
        } else if (err.status === 409) {
          if (err.error.message || err.error) {
            Swal.fire({
              title: 'Lo sentimos, ocurrió un problema.',
              text: err.error
                ? err.error.message || err.error
                : 'Ocurrió un problema.',
              icon: 'warning',
              ...SwalCustomProps,
            });
          }
        } else if (err.status === 500) {
          if (err.error.message) {
            Swal.fire({
              title: 'Lo sentimos, ocurrió un error.',
              text: err.error.message
                ? err.error.message
                : 'Error interno al procesar la solicitud.',
              icon: 'error',
              ...SwalCustomProps,
            });
          }
        }

        return throwError(() => err);
      })
    );
  }
}
